

export default function Line4a (){
    return(
      <div className='text-gray-400 text-c12 pt-2'>© 2023 Airbnb, Inc. All rights reserved.</div>

    )
}